import { render, staticRenderFns } from "./PhotographyServices.vue?vue&type=template&id=a19511de&scoped=true&"
import script from "./PhotographyServices.vue?vue&type=script&lang=js&"
export * from "./PhotographyServices.vue?vue&type=script&lang=js&"
import style0 from "./PhotographyServices.vue?vue&type=style&index=0&id=a19511de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19511de",
  null
  
)

export default component.exports